import { Channel } from './channel';
import { Language } from './language';
import { Partner } from './partners';

export enum TransferReason {
    // The expert has escalated the chat to an expert taskQueue
    ESCALATION = 'Escalation',
    // The expert has not responded to the customer in a timely manner
    NEGLECTION = 'Neglection',
    // The expert has transferred the chat to another taskQueue
    WRONG_QUEUE = 'WrongQueue',
}

/**
 * generates queue name used for transfers
 * @param channel CHAT/VOICE...
 * @param partner VERIZON/ATT...
 * @param queue SUPERVISOR/DEVICE-REPLACEMENT...
 * @param language EN_US/FR_CA....
 * @returns queue name string
 */
export const buildQueueName = (channel: Channel, partner: Partner, queue: string, language: Language) =>
    `${channel.toUpperCase()}:${partner.toUpperCase()}:${queue.toUpperCase()}:${language.toUpperCase()}`;
